import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutGrid, Package, Settings, LogOut, Activity } from "lucide-react";
import { clearSession, getUser } from "@/lib/api";
import { TESTIDS } from "@/constants/testIds";

const NAV_ITEMS = [
  { to: "/", label: "Projects", icon: LayoutGrid, testid: TESTIDS.sidebarProjectsLink, end: true },
  { to: "/packs", label: "Vertical Packs", icon: Package, testid: TESTIDS.sidebarPacksLink },
  { to: "/settings", label: "Settings", icon: Settings, testid: TESTIDS.sidebarSettingsLink },
];

export default function AppShell() {
  const navigate = useNavigate();
  const user = getUser();

  function handleLogout() {
    clearSession();
    navigate("/login", { replace: true });
  }

  return (
    <div className="flex min-h-screen">
      <aside data-testid={TESTIDS.sidebar} className="w-56 border-r border-border bg-card shrink-0 flex flex-col">
        <div className="p-4 border-b border-border">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 grid place-items-center bg-primary text-primary-foreground rounded-sm">
              <Activity className="w-4 h-4" strokeWidth={2.5} />
            </div>
            <div>
              <div className="text-xs txt-mono uppercase tracking-wider text-muted-foreground">Engine</div>
              <div className="text-sm font-semibold leading-tight">UGC Forum</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-2 space-y-0.5">
          {NAV_ITEMS.map(({ to, label, icon: Icon, testid, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 text-sm rounded-sm transition-colors ${
                  isActive
                    ? "bg-primary/15 text-primary border-l-2 border-primary -ml-px"
                    : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-border">
          <div data-testid={TESTIDS.topbarUser} className="text-xs text-muted-foreground mb-2 truncate">
            {user?.email || "Signed in"}
          </div>
          <button
            data-testid={TESTIDS.logoutBtn}
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 text-xs px-3 py-1.5 border border-border hover:border-primary hover:text-primary rounded-sm transition-colors"
          >
            <LogOut className="w-3 h-3" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
